export default "__VITE_ASSET__BVE7tsaZ__"